import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDutyDrawback } from '@carm/_core/declarations/models';

@Injectable()
export class DrawbackViewService {
  private readonly currentDeclarationSubject = new BehaviorSubject<any>(null);

  public get onViewDrawbackChange$(): Observable<any> {
    return this.currentDeclarationSubject.asObservable();
  }

  public setCurrentDrawback(drawback: IDutyDrawback) {
    this.currentDeclarationSubject.next(drawback);
  }
}
